/* Your Photo, Made Into Jewelry — no AI: validate the photo, swap finish, add to cart with the file attached. */
(function () {
  'use strict';
  function init(root) {
    var form = root.querySelector('[data-khp-form]');
    if (!form) return;
    var q = function (s) { return root.querySelector(s); };
    var maxMb = parseFloat(root.getAttribute('data-max-mb')) || 20;
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    var file = q('[data-khp-file]'), drop = q('[data-khp-drop]'), dropText = q('[data-khp-drop-text]'), dropOk = q('[data-khp-drop-ok]');
    var thumb = q('[data-khp-thumb]'), fname = q('[data-khp-file-name]');
    var img = q('[data-khp-img]'), price = q('[data-khp-price]'), variant = q('[data-khp-variant]');
    var err = q('[data-khp-err]'), submit = q('[data-khp-submit]'), label = q('[data-khp-label]');
    var okType = /^image\/(jpeg|png|webp|heic|heif)$/i, okName = /\.(jpe?g|png|webp|heic|heif)$/i;

    function setErr(m) { if (err) err.textContent = m || ''; }
    function current() { return file.files && file.files[0]; }
    function reset() { file.value = ''; if (thumb) thumb.removeAttribute('src'); dropOk.hidden = true; dropText.hidden = false; }
    function showFile() {
      var f = current();
      if (!f) { reset(); return; }
      if (f.size > maxMb * 1048576) { reset(); setErr('That photo is over ' + maxMb + ' MB. Please choose a smaller one.'); return; }
      if (!(okType.test(f.type || '') || okName.test(f.name || ''))) { reset(); setErr('Please choose a JPG, PNG, WEBP or HEIC photo.'); return; }
      setErr('');
      if (fname) fname.textContent = f.name;
      if (thumb) { if (window.URL && /^image\/(jpeg|png|webp)$/i.test(f.type)) thumb.src = URL.createObjectURL(f); else thumb.removeAttribute('src'); }
      dropText.hidden = true; dropOk.hidden = false;
    }
    file.addEventListener('change', showFile);
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (t) { drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (t) { drop.addEventListener(t, function () { drop.classList.remove('is-over'); }); });
    }
    root.querySelectorAll('[data-khp-clear]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); reset(); setErr(''); });
    });
    root.querySelectorAll('[data-khp-radio]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        variant.value = r.value;
        if (img && r.getAttribute('data-img')) img.src = r.getAttribute('data-img');
        if (price && r.getAttribute('data-price')) price.textContent = r.getAttribute('data-price');
      });
    });

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      setErr('');
      if (!current()) { setErr('Please add your photo first.'); if (drop) drop.classList.add('is-over'); return; }
      if (!window.FormData || !window.fetch) { form.submit(); return; }
      var old = label ? label.textContent : '';
      submit.disabled = true; if (label) label.textContent = 'Adding…';
      var fd = new FormData(form);
      fd.delete('khp_variant');
      var story = form.querySelector('textarea[name="properties[Your Story]"]');
      if (story && !story.value.trim()) fd.delete('properties[Your Story]');
      fetch(form.getAttribute('action') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }, function () { return { ok: r.ok, body: null }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add this to your cart.');
          window.location.href = cartUrl;
        })
        .catch(function (e) { setErr(e.message); submit.disabled = false; if (label) label.textContent = old; });
    });
  }
  document.querySelectorAll('[data-kh-photo]').forEach(init);
})();
